document.addEventListener('DOMContentLoaded', () => {
  const PREORDER_KEY = '_is_preorder';

  function isPreorderForm(form) {
    return form.querySelector(`[name="properties[${PREORDER_KEY}]"]`) !== null;
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    return await res.json();
  }

  document.addEventListener(
    'click',
    async (e) => {
      const button = e.target.closest('.product-form__submit[name="add"]');
      if (!button) return;

      const form = button.closest('form');
      if (!form) return;

      if (button.dataset.preorderGuardApproved === 'true') {
        button.dataset.preorderGuardApproved = 'false';
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      try {
        const cart = await getCart();

        const cartHasPreorder = cart.items.some((item) => {
          return item.properties && item.properties[PREORDER_KEY] === 'true';
        });

        const addingPreorder = isPreorderForm(form);
        const cartHasNormalItems = cart.items.length > 0 && !cartHasPreorder;

        if (cartHasPreorder && !addingPreorder) {
          alert('Cette précommande doit être achetée séparément.');
          return;
        }

        if (addingPreorder && cartHasNormalItems) {
          alert('La précommande doit être achetée séparément des autres articles.');
          return;
        }

        button.dataset.preorderGuardApproved = 'true';
        button.click();
      } catch (error) {
        console.error('Preorder guard error:', error);
      }
    },
    true
  );
});